import { Component, OnInit } from '@angular/core';
import {CommonComponent} from '../../shared/common/common.component';
import {BarcodeService} from '../../../services/barcode.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../../services/notifications.service';
import {ToastaService} from 'ngx-toasta';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {DialogService} from 'primeng/dynamicdialog';
import {BarcodeStatus, IBarcode} from '../../../domain/accounts/IBarcode';

@Component({
  selector: 'app-new-code',
  templateUrl: './new-code.component.html',
  styleUrls: ['./new-code.component.scss']
})
export class NewCodeComponent extends CommonComponent implements OnInit {
  barcodes: IBarcode [];
  productName = "";
  iBarcodeStatus = BarcodeStatus;

  constructor(
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    protected router: Router,
    public translate: TranslateService,
    protected dialogService: DialogService,
    private barcodeService: BarcodeService,
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    this.getBarcodes();
    this.barcodes = [];
  }

  ngOnInit(): void {
    this.productName = "UnicaCard"; //This variable must be set from the project configuration
  }

  getBarcodes() {
    this.loadingModalOn();
    this.barcodeService.getBarcodes('').subscribe(
      (response: any) => {
        this.barcodes = response.filter(barcode => {
          return barcode.status !== BarcodeStatus.EXPIRED;
        });
        this.loadingModalOff();
      }, error => {
        this.loadingModalOff();
      }
    );
  }
  getBarcodeClass(barcodeStatus: BarcodeStatus) {
    switch (barcodeStatus) {
      case BarcodeStatus.NEW:
      case BarcodeStatus.PENDING:
        return true;
      default:
        return false;
    }
  }
  openBarcode(content) {
    // this.modalService.open(content, {centered: true});
    this.modalService.open(content, { centered: true, windowClass: 'wrap-modal' });
  }
  openInfoModal(content){
    this.modalService.open(content, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
  }

  linkToCreateCode() {
    this.router.navigate(['/account/createBarcode']);
  }
}
